import { fetchBookingDetail } from 'store/reservationsDetails/actions';

import type { universalRouterProps } from 'core/universalRouter/types';
import type { SearchQuery } from 'ReservationsDetails-Types';

export default ({ store: { dispatch } }: universalRouterProps, query: SearchQuery) => {
  return Promise.all([
    dispatch(fetchBookingDetail(query.params.reservationId, query?.query?.type)),
  ]);
};
